import React from "react";

export default function SectionHeader({ kicker, title, lead }) {
  return (
    <div className="sectionHeader">
      {kicker ? <div className="kicker">{kicker}</div> : null}
      <h2 className="sectionTitle">{title}</h2>
      {lead ? <p className="sectionLead">{lead}</p> : null}
    </div>
  );
}
